var map = {
	"./da.json": [
		"./src/js/translations/da.json",
		13
	],
	"./de.json": [
		"./src/js/translations/de.json",
		14
	],
	"./en.json": [
		"./src/js/translations/en.json",
		15
	],
	"./es.json": [
		"./src/js/translations/es.json",
		16
	],
	"./fr.json": [
		"./src/js/translations/fr.json",
		17
	],
	"./it.json": [
		"./src/js/translations/it.json",
		18
	],
	"./nl.json": [
		"./src/js/translations/nl.json",
		19
	],
	"./no.json": [
		"./src/js/translations/no.json",
		20
	],
	"./pt-BR.json": [
		"./src/js/translations/pt-BR.json",
		21
	],
	"./ru.json": [
		"./src/js/translations/ru.json",
		22
	],
	"./sv.json": [
		"./src/js/translations/sv.json",
		23
	],
	"./whitelist_en.json": [
		"./src/js/translations/whitelist_en.json",
		24
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/js/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;